import * as API from '@/api/index'

/* 供应商统计 */
export const findStatistics = (params) => {
    return API.POST('/A03OtherManagerController/findStatistics', params)
}

/* 供应商统计-柱状图 */
export const findStatisticsGroupByDate = (params) => {
    return API.POST('/A03OtherManagerController/findStatisticsGroupByDate', params)
}

/* 查询供应商列表 */
export const findSupplierList = (params) => {
    return API.POST('/A02SupplierController/findSupplierList', params)
}

/* 查询供应商性质标签 */
export const findSupplierBrand = (params) => {
    return API.POST('/A02SupplierController/findSupplierBrand', params)
}

/* 查询供应商性质标签 */
export const findSupplierNature = (params) => {
    return API.POST('/A02SupplierController/findSupplierNature', params)
}

/* 查询供应商类别标签 */
export const findSupplierTypeTag = (params) => {
    return API.POST('/A02SupplierController/findSupplierTypeTag', params)
}